import TopHeaderItem from "./TopHeaderItem";
import { HeaderLink } from "@/app/lib/features/header/header.types";

interface TopHeaderItemsProps {
  links: HeaderLink[];
}

const TopHeaderItems = ({ links }: TopHeaderItemsProps) => {
  return (
    <div className="flex items-center gap-4">
      {links.map((link, i) => (
        <TopHeaderItem link={link} key={i} />
      ))}
    </div>
  );
};

export default TopHeaderItems;
